import Container from '@ui/container/container';
import HoverCard from '@ui/cards/hover-card/hover-card';
import PreHoverContent from '@ui/cards/hover-card/pre-hover-content';
import HoverContent from '@ui/cards/hover-card/hover-content';
import Button from '@ui/buttons/button/button';
import Text from '@ui/text/text/text';
import { CampaignTemplate } from '@/connection/campaigns/fetch-campaign-templates';
import TemplateThumbnail from './template-thumbnail';
import { EColorVariablesV2 } from '@/types/theme-packs.types';
import getThemeColorContrastCSSVariable from '@/utils/colors/get-theme-color-contrast-css-variable';
import getThemeColorsCssMixVariable from '@/utils/colors/get-theme-color-css-mix-variable';
import getThemeColorCSSVariable from '@/utils/colors/get-theme-color-css-variable';

interface SuiteCardProps {
  template: CampaignTemplate;
  onPreview: (template: CampaignTemplate) => void;
}

export default function SuiteCard({ template, onPreview }: SuiteCardProps) {
  return (
    <Container className="flex-column gap-12 invisible-offscreen" data-component="SuiteCard" flex="1">
      <HoverCard type="fade" width="100%" aspectRatio="16 / 9" containerClassName="radius-12">
        <PreHoverContent>
          <TemplateThumbnail templateUuid={template.uuid} />
        </PreHoverContent>

        <HoverContent backgroundColor="rgba(var(--gray-1100-rgb), 0.5)">
          <Container className="flex jc-center ai-center" height="100%" width="100%">
            <Button
              className="L1"
              backgroundColor={getThemeColorCSSVariable()}
              hoverBackgroundColor={getThemeColorsCssMixVariable()}
              color={getThemeColorContrastCSSVariable(EColorVariablesV2.buttonText, EColorVariablesV2.primary)}
              onClick={() => onPreview(template)}
              borderRadius="100px"
              padding="12px 32px"
            >
              <Text
                color={getThemeColorContrastCSSVariable(EColorVariablesV2.buttonText, EColorVariablesV2.primary)}
                className="L1"
              >
                Preview
              </Text>
            </Button>
          </Container>
        </HoverContent>
      </HoverCard>

      <Container maxWidth="100%">
        <Text className="H5" clamp={1} design="GlobalIcoText2">
          {template.title || template.category}
        </Text>
      </Container>
    </Container>
  );
}
